export const FETCH_ALL_CATEGORIES = 'FETCH_ALL_CATEGORIES';

export const FETCH_LINK_TYPES = 'FETCH_LINK_TYPES';